import React, { useEffect, useState } from 'react';
import StatCard from '../../../components/common/StatCard';
import Icon from '../../../components/common/Icon';
import { getClubDashboardApi } from '../../../api/dashboard.api';
import useAuth from '../../../hooks/useAuth';

export default function ClubDashboard() {
  const { user } = useAuth();
  const [data, setData] = useState(null);

  useEffect(() => {
    getClubDashboardApi().then(({ data }) => setData(data.data));
  }, []);

  return (
    <div className="space-y-6 animate-fade-in">
      {/* هدر خوش‌آمدگویی */}
      <div className="hero-panel relative isolate overflow-hidden rounded-[2rem] bg-ink p-6 text-white shadow-[0_30px_70px_-30px_rgba(7,21,15,0.7)] sm:p-8">
        <div className="pointer-events-none absolute -left-10 -top-16 h-44 w-44 rounded-full bg-floodlight/20 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-20 right-10 h-52 w-52 rounded-full bg-emerald-400/25 blur-3xl" />

        <div className="relative flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <div className="mb-3 flex items-center gap-2 text-floodlight">
              <span className="grid h-9 w-9 place-items-center rounded-full bg-floodlight/15">
                <Icon name="shield" className="h-4 w-4" />
              </span>
              <span className="text-xs font-bold">داشبورد باشگاه</span>
            </div>

            <h1 className="text-2xl font-black sm:text-3xl">
              خوش آمدید، {user?.fullName}
            </h1>

            {data?.club && (
              <p className="mt-2 text-sm text-white/60">
                باشگاه: <span className="font-bold text-white">{data.club.name}</span>
              </p>
            )}
          </div>

          <div className="glass-dark inline-flex items-center gap-2 self-start rounded-full px-5 py-3 text-xs font-black text-floodlight sm:self-auto">
            <span className="h-2 w-2 animate-pulse rounded-full bg-floodlight" />
            سامانه فعال است
          </div>
        </div>
      </div>

      {data ? (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          <StatCard title="بازیکنان فعال" value={data.players.total} icon="users" color="lime" />
          <StatCard title="مسابقات پیش رو" value={data.matches.upcoming} icon="ball" />
          <StatCard title="تیکت های باز" value={data.tickets.open} icon="ticket" color="amber" />
        </div>
      ) : (
        <div className="glass rounded-[2rem] py-12 text-center text-sm font-bold text-slate-400">
          در حال بارگذاری...
        </div>
      )}
    </div>
  );
}
